import LoadingIndicator from "app/core/components/LoadingIndicator"
import { isAppError } from "app/errors"
import React, { Suspense } from "react"
import { GracefulErrorDisplay } from "app/core/components/error-handlers/GracefulErrorDisplay"
import { CSRFErrorDisplay } from "app/core/components/error-handlers/CSRFErrorDisplay"

const GracefulErrorFallback = ({ error }) => {
  if (isAppError(error, "CSRFTokenMismatchError")) {
    return (
      <Suspense fallback={LoadingIndicator()}>
        <CSRFErrorDisplay />
      </Suspense>
    )
  }
  if (isAppError(error, "AuthorizationError")) {
    return (
      <Suspense fallback={LoadingIndicator()}>
        <GracefulErrorDisplay
          icon={
            <span>
              <i className="bi bi-shield-lock text-danger fs-1" />
            </span>
          }
          title={error.message || "Sorry, you are not allowed to access this page"}
          fullHeight={true}
        />
      </Suspense>
    )
  }

  if (isAppError(error, "NotFoundError")) {
    return (
      <Suspense fallback={LoadingIndicator()}>
        <GracefulErrorDisplay
          icon={
            <span className="text-danger fs-1">
              <i className="bi bi-4-circle-fill mx-1"></i>
              <i className="bi bi-question-circle-fill mx-1"></i>
              <i className="bi bi-4-circle-fill mx-1"></i>
            </span>
          }
          title={error.message || "This page could not be found"}
          fullHeight={true}
        />
      </Suspense>
    )
  }

  return (
    <Suspense fallback={LoadingIndicator()}>
      <GracefulErrorDisplay
        icon={
          <span className="text-danger fs-1">
            <i className="bi bi-slash-square me-2"></i>
            {error.statusCode || 400}
          </span>
        }
        title={error.message || error.name}
        fullHeight={true}
      />
    </Suspense>
  )
}

export default GracefulErrorFallback
